import axios from "axios";

const api = axios.create({
  baseURL: "https://indicadores.cncg.org.br/api",
  //baseURL: "http://localhost:8080/api",
});

// Adiciona o token JWT automaticamente a todas as requisições
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export default api;
